import { ProductDetailsSections, ProductPage } from '@api/types';
import { createContext } from 'react';

export type ProductSections = { [key in ProductDetailsSections]?: boolean };

export type ProductDetailsContextType = {
  product?: ProductPage;
  sections?: ProductSections;
  onSectionEnter?: (sectionId: string) => any;
  isInTransition?: boolean;
};

export const ProductDetailsContext = createContext<ProductDetailsContextType>({});
